var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRonUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.36092L12.0667 1.68391C11.519 1.2245 10.7777 0.966579 10.005 0.966579C9.23228 0.966578 8.49101 1.2245 7.94333 1.68391L1.33092e-07 8.36864L1.7675 9.85547L9.71 3.17144C9.78814 3.1056 9.8941 3.06862 10.0046 3.06862C10.1151 3.06862 10.221 3.1056 10.2992 3.17144L18.2325 9.84774L20 8.36092Z",
    fill: "#A1A1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRonUp);
export default __webpack_public_path__ + "static/media/ronUp.effc73a5e7b1dbaf213490d87025c220.svg";
export { ForwardRef as ReactComponent };